import React, { useEffect, useRef, useState } from "react";
import styles from "./Predicas.module.css";
import SearchIcon from '@mui/icons-material/Search';
import ImageOverlay from "../../components/ImageOverLay/ImageOverlay";
import VideoModal from "../../components/VideoModal/VideoModal";
import { UploadVideo, videosLogic } from "../../../Logic/Videos";
import HomeIcono from "../../components/HomeIcon/HomeIcono";
import { statisticsLogic } from "../../../Logic/Statistics";


const Predicas: React.FC = () => {

    const [selectedFilter, setSelectedFilter] = useState<string>("");
    const [videos, setVideos] = useState<UploadVideo[]>([]);
    const [loading, setLoading] = useState(false);
    const [selectedVideo, setSelectedVideo] = useState<UploadVideo | null>(null); // Para abrir el modal

    const [searchActive, setSearchActive] = useState(false);
    const [searchText, setSearchText] = useState("");
    const searchRef = useRef<HTMLInputElement>(null);
    const [usuario, setUsuario] = useState<{ nombre: string; email: string } | null>(null);
    const [sessionID, setSessionID] = useState("");

    const preachers = ["Isaac", "Daniel", "Andrea", "Karime", "Juan", "Gabriela"];
    const topics = ["Matrimonio", "Padres", "Familia", "Parasha", "Tefilá", "Purim", "Pesaj", "Shavuot", "Yom Teruah", "Sukkot", "Yom Kippur" ,"Sulam"];
    const years = ["2026","2025","2024","2023","2022","2021","2020"];
  
    const handleFilterSelect = (filter: string, searchBar: boolean) => {
      setSelectedFilter(filter);

      //get user name 
      var userName = usuario != null ? usuario.nombre : "Unknown - "+ sessionID
      statisticsLogic.RegisterStat({"Nombre":userName, "Funcionalidad":"Search - " + (searchBar ? "Bar": "Filter"), "Valor":filter})
    };

    function showVideoInModal (video : UploadVideo){

      setSelectedVideo(video);

      //get user name 
      var userName = usuario != null ? usuario.nombre : "Unknown - "+ sessionID
      statisticsLogic.RegisterStat({"Nombre":userName, "Funcionalidad":"Play Predica", "Valor":"null"})
    }

    const decodeHtmlText = (html: string) => {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    };
    
   //get session & user registered if exist 
    useEffect(() =>{
      const data = localStorage.getItem("usuarioRegistrado");
      const session = localStorage.getItem("c7_sessionID");
    
      if (data) {
        const usuarioRegistrado = JSON.parse(data);
        setUsuario(usuarioRegistrado);
      }

      if(session){
        setSessionID(session)
      }

    },[])

useEffect(() => {

  if (searchActive && searchRef.current) {
    searchRef.current.focus();
  }

    try 
    {
      if (!selectedFilter) return;

      setLoading(true);

      if(years.some(x => x === selectedFilter)){
        videosLogic.GetVideosByYear(selectedFilter).then((videos: UploadVideo[]) => {
          console.log(videos);
          setVideos(videos);
        })
      } else {
        videosLogic.GetVideosByFilterText(selectedFilter).then((videos: UploadVideo[]) => {
          console.log(videos);
          setVideos(videos);
        })
      }
    } 
    catch (error) 
    {
      console.error("Error al obtener videos:", error);
      setVideos([]);
    } 
    finally 
    {
      setLoading(false);
    }
  }, [selectedFilter]);
  
  
    return (
      <div className={styles.mainPredicas}>
      
      <HomeIcono></HomeIcono>

        <div className={styles.header}>
          <h1>Prédicas</h1>
        </div>
  
        <div className={styles.container}>
          <div className={styles.mainContent}>
            {/* Sección de Filtros */}
            <div className={styles.filterSection}>
            <div className={`${styles.searchContainer} ${searchActive ? styles.active : ""}`}>
              <input
                type="text"
                placeholder="Buscar..."
                className={styles.searchInput}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                ref={searchRef}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && searchText.trim()) {
                    handleFilterSelect(searchText.trim(), true);
                    setTimeout(() => {
                      searchRef.current?.blur();  // Cerrar el teclado al quitar el foco
                    }, 200);  // Espera 200ms para asegurar que el filtro se aplica antes de quitar el foco
                }
                }}
              />
              <SearchIcon  className={styles.searchToggle}
                onClick={() => {
                  if (searchActive && searchText) {
                    setSearchText(""); // Limpiar texto al cerrar
                  }
                  setSearchActive((prev) => !prev);
                }}></SearchIcon>
            </div>
              <h3>Orador</h3>
              <div className={styles.buttonGroup}>
                {preachers.map((preacher) => (
                  <button
                    key={preacher}
                    className={`${styles.filterButton} ${selectedFilter === preacher ? styles.selected : ""}`}
                    onClick={() => handleFilterSelect(preacher, false)}
                  >
                    {preacher}
                  </button>
                ))}
              </div>
  
              <h3>Temas</h3>
              <div className={styles.buttonGroup}>
                {topics.map((topic) => (
                  <button
                    key={topic}
                    className={`${styles.filterButton} ${selectedFilter === topic ? styles.selected : ""}`}
                    onClick={() => handleFilterSelect(topic, false)}
                  >
                    {topic}
                  </button>
                ))}
              </div>
  
              <h3>Año</h3>
              <div className={styles.buttonGroup}>
                {years.map((year) => (
                  <button
                    key={year}
                    className={`${styles.filterButton} ${selectedFilter === year ? styles.selected : ""}`}
                    onClick={() => handleFilterSelect(year, false)}
                  >
                    {year}
                  </button>
                ))}
              </div>
            </div>
  
            {/* Lista de videos */}
            <div className={styles.videoList}>
              {loading ? (
                <p>Cargando videos...</p>
              ) : videos.length > 0 ? (
                videos.map((video, index) => (
                    <div  className={styles.videoCard} key={index}>
                       <ImageOverlay
                                      src={video.thumbnail}
                                      alt={video.title}
                                      text="Reproducir"
                                      onClick={() => showVideoInModal(video)}
                                />
                          <h4>{decodeHtmlText(video.title)}</h4>
                          <p>Publicado el: {new Date(video.published_at).toLocaleString('es-ES', {day: '2-digit',month: '2-digit', year: 'numeric',})}</p>
                  </div>
                ))
              ) : (
                <p>No se encontraron videos.</p>
              )}
            </div>
          </div>
        </div>

        {/* Modal para reproducir el video */}
      {selectedVideo && <VideoModal videoId={videosLogic.GetYouTubeVideoIdFromUrl(selectedVideo.url)} onClick={() => setSelectedVideo(null) }></VideoModal> }
      </div>
    );
};

export default Predicas;
